import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import yandexDirectLogo from "@/shared/assets/yandex-direct.svg";

export interface ClientHeaderProps {
  clientLogin: string;
  clientInfo?: string | null;
  clientId?: string | number | null;
}

export const ClientHeader = ({
  clientLogin,
  clientInfo,
  clientId,
}: ClientHeaderProps) => {
  return (
    <div className="flex flex-col gap-3">
      {/* Кнопка «Назад к клиентам» */}
      <div>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-xs font-medium text-neutral-400 hover:text-neutral-200 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Назад к клиентам</span>
        </Link>
      </div>

      {/* Заголовок клиента без обёртки в карточку */}
      <div className="flex flex-row items-center gap-4">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold truncate leading-snug">
            {clientInfo || clientLogin}
          </h1>
          <p className="text-xs text-neutral-400">
            Логин: {clientLogin} {clientId ? `• ID: ${clientId}` : ""}
          </p>
        </div>
      </div>
    </div>
  );
};
